// @flow
import type { CleanupToken, Dispatch, GetState, User } from 'state/types';
import {
  getCatalogs as getCatalogsSelector,
  getIdentitySession,
  getUsers as getUsersSelector,
} from 'state/selectors';
import { goToRoute } from 'util/routeUtils';
import { NAME_PUBLISHER } from 'util/roleUtils';
import {
  addNotification,
  SUCCESS_LEVEL,
} from 'portfolio-shared/state/commands/globalNotificationsCommands';
import {
  createUser as createUserAction,
  deleteUsers as deleteUsersAction,
  getUsers as getUsersAction,
  updateUser as updateUserAction,
} from 'state/reducers/userReducer';
import { actions as catalogActions } from 'state/reducers/catalogReducer';
const {
  addOrUpdateUserCatalogInfo: addOrUpdateUserCatalogInfoAction,
  getCatalogs: getCatalogsAction,
} = catalogActions;

export function getUsers() {
  return async function getUsers(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(getUsersAction(session));
    }
  };
}

export function updateUser(user: User, successMessage: string) {
  return async function updateUser(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      const {
        payload: [updatedUser],
      } = await dispatch(updateUserAction(session, user));
      await dispatch(getUsersAction(session));
      dispatch(addNotification(successMessage, SUCCESS_LEVEL));
      return updatedUser;
    }
  };
}

export function createUser(
  user: User,
  addUserToAllCatalogs: boolean = false,
  roleName: string = NAME_PUBLISHER
) {
  return async function createUser(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(createUserAction(session, user));
      await dispatch(getUsersAction(session));
      const users = getUsersSelector(getState());
      const userToSelect = users.find(u => u.name === user.name);
      if (userToSelect && userToSelect.uuid) {
        goToRoute(`users/${userToSelect.uuid}`);
      }

      if (addUserToAllCatalogs) {
        await dispatch(getCatalogsAction(session));
        const catalogs = getCatalogsSelector(getState());

        const userInfos = catalogs.map(catalog => ({
          accountName: user.name,
          roleName: roleName,
          catalogName: catalog.name,
        }));

        if (userInfos.length > 0) {
          await dispatch(addOrUpdateUserCatalogInfoAction(session, userInfos));
        }
      }
    }
  };
}

export function deleteUsers(users: User[], cleanupTokens: CleanupToken[] = []) {
  return async function deleteUsers(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(deleteUsersAction(session, users, cleanupTokens));
      await dispatch(getUsersAction(session));
    }
  };
}



// WEBPACK FOOTER //
// ./src/state/commands/userCommands.js